/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector(".sub-menu");
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener("click", (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains("active")) {
      submenu.classList.add("active");
    } else {
      submenu.classList.remove("active");
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll(".thb-arrow");
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});


// footer mobile menu js
window.addEventListener("load", function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    const widgets = document.querySelectorAll(".footer-menu-main .widget");

    widgets.forEach((widget) => {
      widget.addEventListener("click", function () {
        const menu = widget.querySelector(".thb-widget-menu");
        const plusIcon = widget.querySelector(".thb-widget-title .footer-menu-plus");

        if (menu) {
          const isOpen = menu.style.display === "block" || window.getComputedStyle(menu).display === "block";

          if (isOpen) {
            // Slide up
            menu.style.overflow = "hidden";
            menu.style.height = menu.scrollHeight + "px";

            requestAnimationFrame(() => {
              menu.style.transition = "height 300ms ease";
              menu.style.height = "0px";
            });

            menu.addEventListener("transitionend", function handler() {
              menu.style.display = "none";
              menu.style.height = "";
              menu.style.overflow = "";
              menu.style.transition = "";
              menu.removeEventListener("transitionend", handler);
            });

            // Show the plus icon
            if (plusIcon) {
              plusIcon.setAttribute("style", "display: inline-block !important;");
            }
          } else {
            // Slide down
            menu.style.display = "block";
            menu.style.height = "0px";
            menu.style.overflow = "hidden";
            const fullHeight = menu.scrollHeight + "px";

            requestAnimationFrame(() => {
              menu.style.transition = "height 300ms ease";
              menu.style.height = fullHeight;
            });

            menu.addEventListener("transitionend", function handler() {
              menu.style.height = "";
              menu.style.overflow = "";
              menu.style.transition = "";
              menu.removeEventListener("transitionend", handler);
            });

            // Hide the plus icon
            if (plusIcon) {
              plusIcon.setAttribute("style", "display: none !important;");
            }
          }
        }
      });
    });
  }
});
